import { render } from "./DetailsItem.vue?vue&type=template&id=02263e12&scoped=true"
import script from "./DetailsItem.vue?vue&type=script&lang=js"
export * from "./DetailsItem.vue?vue&type=script&lang=js"

import "./DetailsItem.vue?vue&type=style&index=0&id=02263e12&lang=scss&scoped=true"

import exportComponent from "/app/tmp/blackhall/V3/v2026.6.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02263e12"]])

export default __exports__